import { Anchor, Card } from '@zenid/web';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';

export function NotFound() {
  return (
    <Card
      className={css({
        width: '100%',
        height: '472px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.16}',
        sm: {
          height: '434px',
          padding: '{spacing.48} {spacing.32}',
        },
      })}
    >
      <div className={flex({ flexDirection: 'column', gap: '{spacing.24}', justifyContent: 'center' })}>
        <div className={flex({ justifyContent: 'center' })}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_telescope.png`}
            className={css({ width: '100px', height: '100px', sm: { width: '120px', height: '120px' } })}
            alt="NotFoundページのアイコン"
          />
        </div>
        <div className={flex({ flexDirection: 'column', gap: '{spacing.16}' })}>
          <h1
            className={css({
              color: '{colors.text.main}',
              textStyle: 'headding.l',
              textAlign: 'center',
              wordBreak: 'keep-all',
            })}
          >
            ページが見つかりませんでした
          </h1>
          <p
            className={css({
              color: '{colors.text.main}',
              textStyle: 'body.m.default',
              textAlign: 'center',
              wordBreak: 'keep-all',
            })}
          >
            ご指定のページは削除・変更されたか、現在ご利用いただけない可能性があります。
            <br />
            お手数ですが、「ZEN ID」トップページより再度お探しください。
          </p>
        </div>
        <div className={flex({ justifyContent: 'center', paddingTop: '{spacing.20}' })}>
          <Anchor variant="button" href="/home" color="primary" size="l" width={200}>
            ZEN IDに戻る
          </Anchor>
        </div>
      </div>
    </Card>
  );
}
